import type { IRemoteConfigService } from "../interfaces/remote-config";

let service: IRemoteConfigService | null = null;

export function registerRemoteConfigService(svc: IRemoteConfigService): void {
  service = svc;
}

export function getRemoteConfigService(): IRemoteConfigService {
  if (!service) {
    throw new Error(
      "RemoteConfigService not registered. Call registerRemoteConfigService() from your host app before using remote config in modules.",
    );
  }
  return service;
}
